"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let navigator = typeof window === "object" ? window.navigator : (() => { })();
exports.detectFallback = () => {
    if (!navigator)
        return false;
    const isEdgeOrIE = navigator.appName === "Microsoft Internet Explorer" ||
        (navigator.appName === "Netscape" &&
            /(Trident|Edge)/i.test(navigator.appVersion));
    return isEdgeOrIE;
};
//# sourceMappingURL=detectFallback.js.map